import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { CommonStyles } from '../../../styles';
import EventCancelModal from './EventCancelModal';
import EventItem from './EventItem';
import EventSelector from './EventSelector';
import MeetingDetailsModal from './MeetingDetailsModal';

const hardCodedDays = [
  {
    id: 'all',
    label: 'All Days',
  },
  {
    id: 'jun20',
    label: 'Mon, Jun 20',
  },
  {
    id: 'jun21',
    label: 'Tue, Jun 21',
  },
  {
    id: 'jun22',
    label: 'Wed, Jun 22',
  },
  {
    id: 'jun23',
    label: 'Thu, Jun 23',
  },
];

const hardCodedEvents = {
  '24-05-2021': [
    { day: 'Monday', Title: 'Test' },
    { day: 'Monday', Title: 'Test 1', user: true },
  ],
  '25-05-2021': [
    { day: 'Monday', Title: 'Test 2' },
    { day: 'Monday', Title: 'Test 3' },
  ],
  '26-05-2021': [
    { day: 'Monday', Title: 'Test 4' },
    { day: 'Monday', Title: 'Test 5' },
  ],
  '27-05-2021': [
    { day: 'Monday', Title: 'Test 6' },
    { day: 'Monday', Title: 'Test 7' },
  ],
  '28-05-2021': [
    { day: 'Monday', Title: 'Test 8' },
    { day: 'Monday', Title: 'Test 9' },
  ],
};

const daysOfTheWeek = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thurday',
  5: 'Friday',
  6: 'Saturday',
};

const createDate = (meeting) => {
  //console.log('meeting ', meeting);
  const _date = new Date(meeting.date);
  return new Date(
    _date.getFullYear(),
    _date.getMonth(),
    _date.getDate(),
    meeting.time?.hours,
    meeting.time?.minutes,
    0
  );
};

const EventSection = ({ meetings = {} }) => {
  const [days, setDays] = useState(hardCodedDays);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedDay, setSelectedDay] = useState('all');
  const [selectedMeeting, setSelectedMeeting] = useState(null);

  const _selectedDays = Object.values(meetings || {}).map((meeting) => ({
    label: meeting.date,
    id: meeting.id,
  }));
  const selectedDays = [{ label: 'All Days', id: 'all' }, ...new Set(_selectedDays)];
  const selectedEvents = Object.values(meetings || {}).reduce((arr, meeting) => {
    const date = createDate(meeting);
    //console.log('date created  ', date);
    if (!arr[meeting.date]) {
      arr[meeting.date] = [];
    }
    arr[meeting.date].push({
      id: meeting.id,
      day: daysOfTheWeek[date.getDay()],
      Title: meeting.name,
      EventDate: date,
      description: meeting.description,
      address: meeting.address,
    });

    return arr;
  }, {});

  //console.log('seleced events ', selectedEvents);
  const onChangeSelection = (day) => {
    setSelectedDay(day);
  };

  const onSelect = (activity) => {
    console.log('activity ', activity);
    setShowDetails(true);
    setSelectedMeeting(activity);
  };

  const onDelete = () => {
    console.log('delete ');
  };

  return (
    <View>
      <MeetingDetailsModal
        visible={selectedMeeting}
        meeting={selectedMeeting}
        onClose={() => setSelectedMeeting(null)}
        onDelete={onDelete}
      />
      <EventSelector
        style={CommonStyles.my5}
        days={selectedDays}
        selected={selectedDay}
        onChange={onChangeSelection}
      />
      {selectedEvents
        ? Object.keys(selectedEvents).map((date) => (
            <EventItem
              key={date}
              //isLast={index === Object.keys(hardCodedEvents).length - 1}
              item={{ day: date, activities: selectedEvents[date] }}
              onSelect={onSelect}
              //moreEnabled=
            />
          ))
        : null}
    </View>
  );
};

export default EventSection;

const styles = StyleSheet.create({});
